const controller = require('./internalCtrl.js');
const template = require('./internal.html');

const config = $stateProvider => {
  const internalState = {
    url: '/internal/:date/:page',
    params: {
      date: {
        value: 'all',
      },
      page: {
        value: '1',
        squash: true,
      },
    },
    controller,
    controllerAs: 'vm',
    template,
  };

  $stateProvider.state('bench.dms.internal', internalState);
};

const deps = [require('ui/web/documentCard').name];

module.exports = angular.module('bench.app.dms.internal', deps).config(config);
